/**
 * 配置相关数据
 */
export class Setting {
  /** 虚线段长度 */
  static dashSize = 10

  /** 标注配置 */
  static readonly dimensionConfig = {
    color: 0x06fffd, // 标注颜色
    opacity: 0.5, // 标注透明度
    textColor: '#06FFFD', // 文字颜色
    textSize: 16, // 文字大小
    linewidth: 2, // 线宽
  }

  /**
   * 合并更新标注样式配置。
   *
   * @param config - 需要覆盖的标注样式字段
   */
  static setDimensionConfig(config: Partial<typeof this.dimensionConfig>) {
    Object.assign(Setting.dimensionConfig, config)
  }

  /** 引导线配置 */
  static readonly leadLineConfig = {
    color: 0xffa500, // 颜色
    opacity: 1, // 透明度
  }

  /**
   * 合并更新引导线样式配置。
   *
   * @param config - 需要覆盖的引导线样式字段
   */
  static setLeadLineConfig(config: Partial<typeof this.leadLineConfig>) {
    Object.assign(Setting.leadLineConfig, config)
  }

  /** 预览线配置 */
  static readonly previewLineConfig = {
    color: 0x06fffd, // 颜色
    opacity: 1, // 透明度
  }

  /**
   * 合并更新预览线样式配置。
   *
   * @param config - 需要覆盖的预览线样式字段
   */
  static setPreviewLineConfig(config: Partial<typeof this.previewLineConfig>) {
    Object.assign(Setting.previewLineConfig, config)
  }

  /** 控制点配置 */
  static readonly gripConfig = {
    color: 0xffffff,
    hoverColor: 0xffc107,
    activeColor: 0x00ffff,
    pixelRadius: 6,
    hitPadding: 4,
    depthTest: false,
    depthWrite: false,
  }

  /**
   * 合并更新控制点样式配置。
   *
   * @param config - 需要覆盖的控制点样式字段
   */
  static setGripConfig(config: Partial<typeof this.gripConfig>) {
    Object.assign(Setting.gripConfig, config)
  }
}
